module.exports = __webpack_public_path__ + "static/media/BYU.39beb4a6.png";